import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const Dropzone = observer(
  ({ drop }: { drop: (csvFile: File[]) => Promise<void> }): JSX.Element => {
    const onDrop = useCallback(async (acceptedFiles: File[]) => {
      if (acceptedFiles[0]) {
        drop(acceptedFiles);
      }
    }, []);

    const { getRootProps, getInputProps, open } = useDropzone({
      noClick: true,
      onDrop,
    });

    return (
      <section className="container">
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderWidth: 2,
            borderRadius: 2,
            borderColor: '#eeeeee',
            borderStyle: 'dashed',
            backgroundColor: '#fafafa',
            color: '#bdbdbd',
            outline: 'none',
            transition: 'border .24s ease-in-out',
            minHeight: '90px',
            paddingTop: '26px',
            width: '100%',
            margin: '0 auto',
            cursor: 'pointer',
          }}
          {...getRootProps({ className: 'dropzone' })}
        >
          <input id="video" {...getInputProps()} />
          <button
            style={{
              border: 'none',
              background: 'unset',
              cursor: 'pointer',
              width: '100%',
            }}
            type="button"
            onClick={open}
          >
            <p>Files hineinziehen oder per Klick auswählen</p>
          </button>
        </div>
      </section>
    );
  },
);

export default Dropzone;
